import React from 'react';
import { Box, Container } from '@mui/material';
import Navigation from './Navigation';
import PortalFooter from './PortalFooter';

interface PortalLayoutProps {
  children: React.ReactNode;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

const PortalLayout: React.FC<PortalLayoutProps> = ({ children, maxWidth = 'lg' }) => {
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', backgroundColor: '#f8f9fa' }}>
      <Navigation />
      
      <Box sx={{ flex: 1, py: { xs: 3, md: 6 } }}>
        <Container maxWidth={maxWidth}>
          {children}
        </Container>
      </Box>
      
      <PortalFooter />
    </Box>
  );
};

export default PortalLayout;
